import useCombinedRefs from 'hooks/use-combined-refs';
import * as React from 'react';

import style from './style.module.css';
import MantineDatePicker, { DatePickerInputProps } from '../../date-picker';

interface Props extends DatePickerInputProps {}

const TableDateInput = React.forwardRef<HTMLInputElement, Props>(
  (props, ref) => {
    //TODO: if any problem with useCombinedRef
    const innerRef = React.useRef<HTMLDivElement | null>(null);
    const combinedRef: any = useCombinedRefs(ref, innerRef);

    return (
      <div className={style.tableDateInput}>
        <MantineDatePicker
          ref={combinedRef}
          {...props}
          defaultValue={null}
          popoverProps={{ withinPortal: true }}
          variant="unstyled"
          size="xs"
          styles={{
            input: {
              height: '100%',
              padding: 8,
              fontSize: '16px',
            },
          }}
        />
      </div>
    );
  },
);

TableDateInput.displayName = 'TableDateInput';

export default TableDateInput;
